// @pages/BlogSummaryPage.jsx
import React, { useEffect, useMemo, useState } from "react";
import "@styles/pages/GenericPage/VideoBlogSummaryPage/VideoBlogSummaryPage.scss";
import { getBlogList } from "@api/landingApi";
import { getOptionData } from "@api/commonApi";
import { blogFilterData } from "@data/FilterData";
import SummaryCardList from "@pages/GenericPage/VideoBlogSummaryPage/SummaryCardList";
import { Box, Typography } from "@mui/material";
import { Trans } from "react-i18next";

export default function BlogSummaryPage() {
  const [blogCardList, setBlogCardList] = useState([]);
  const [blogFilterOptions, setBlogFilterOptions] = useState({});

  const combinedBlogFilterList = useMemo(() => [...blogFilterData], []);

  useEffect(() => {
    (async () => {
      try {
        const res = await getBlogList();
        setBlogCardList(res.data.Data || []);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const result = {};
      for (const f of combinedBlogFilterList) {
        try {
          if (f.staticOptions) {
            result[f.type] = f.staticOptions;
          } else {
            const res = await getOptionData({ type: f.type });
            result[f.type] = res?.data?.Data || [];
          }
        } catch (e) {
          console.error("Failed to fetch", f.type, e);
        }
      }
      setBlogFilterOptions(result);
    })();
  }, [combinedBlogFilterList]);

  return (
    <Box className="video-blog-summary-page-container">
      <Box className="title-container">
        <Typography className="title">
          <Trans i18nKey="generic:blog" />
        </Typography>
      </Box>

      <SummaryCardList
        cardType="blog"
        filterData={combinedBlogFilterList}
        filterOptions={blogFilterOptions}
        cardList={blogCardList}
      />
    </Box>
  );
}
